/**
 * Rare equipment (04 §6). The suppressed pistol is the point of the whole item: a soft cough and
 * a slide, nothing a sentry forty metres off would turn his head for - so it is mixed low and
 * dies within a few metres, the opposite of the carbine.
 */

import { PRIORITY, type SfxDef } from './types';

export const GEAR_SFX = {
  pistolSuppressed: {
    variants: 3, priority: PRIORITY.action, gain: 0.45, maxDistance: 25, rateSpread: 0.04,
    patch: {
      layers: [
        { wave: 'noise', decay: 0.045, curve: 3, gain: 1, filter: { type: 'lp', cutoff: 1500, cutoffEnd: 420 } },
        { wave: 'sine', freq: 150, freqEnd: 70, sweep: 0.4, decay: 0.05, gain: 0.5 },
        // The slide coming home: a dry tick just after the cough.
        { wave: 'noise', at: 0.05, decay: 0.018, curve: 4, gain: 0.35, filter: { type: 'bp', cutoff: 3200, q: 3 } },
      ],
      jitter: { pitch: 0.05, time: 0.1, gain: 0.1 },
    },
  },
  smokeHiss: {
    variants: 2, priority: PRIORITY.cue, gain: 0.5, maxDistance: 45,
    patch: {
      layers: [
        { wave: 'noise', decay: 0.03, curve: 3, gain: 0.8, filter: { type: 'bp', cutoff: 1800, q: 1.5 } },
        { wave: 'pink', at: 0.03, attack: 0.08, decay: 1.6, curve: 1.6, gain: 0.7,
          filter: { type: 'hp', cutoff: 2400, cutoffEnd: 900 } },
      ],
      jitter: { pitch: 0.04, time: 0.1, gain: 0.1 },
    },
  },
  tagsTaken: {
    variants: 1, priority: PRIORITY.action, gain: 0.5,
    patch: {
      layers: [
        { wave: 'sine', freq: 2300, fmRatio: 3.1, fmIndex: 1.6, fmDecay: 0.03, decay: 0.16, curve: 3, gain: 0.7 },
        { wave: 'sine', at: 0.07, freq: 2750, fmRatio: 3.1, fmIndex: 1.4, fmDecay: 0.03, decay: 0.22, curve: 3, gain: 0.6 },
      ],
    },
  },
  // Mission 3 lost: the jets he came for, leaving. A long rising roar that thins out to nothing.
  jetsAway: {
    // Every jet leaves on the same tick: one roar, not one each.
    variants: 1, priority: PRIORITY.critical, gain: 0.7, minInterval: 3,
    patch: {
      layers: [
        { wave: 'pink', attack: 0.5, decay: 2.6, curve: 1.4, gain: 1, filter: { type: 'bp', cutoff: 380, cutoffEnd: 2400, q: 0.9 } },
        { wave: 'noise', at: 0.4, attack: 0.6, decay: 2.2, curve: 1.8, gain: 0.5,
          filter: { type: 'hp', cutoff: 1200, cutoffEnd: 5200 } },
        { wave: 'sine', freq: 95, freqEnd: 240, sweep: 0.9, attack: 0.4, decay: 2.4, gain: 0.45 },
      ],
    },
  },
} satisfies Record<string, SfxDef>;
